export default __webpack_public_path__ + "static/media/179.3072eec1.svg";